<script lang="ts">
	import type { ButtonColor, ButtonSize, ButtonVariant } from '$lib/components/atoms/button/types';
	import type { ClassValue } from 'svelte/elements';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import ModalDialog from '$lib/components/modals/ModalDialog.svelte';
	import TheForkWidgetDialog from '$lib/components/theFork/TheForkWidgetDialog.svelte';
	import { isMobile } from '$lib/services/mediaQuery/screenSize';
	import * as m from '$paraglide/messages';

	interface Props {
		url: string;
		color?: ButtonColor;
		size?: ButtonSize;
		variant?: ButtonVariant;
		class?: ClassValue;
		onBookClick?: (event: MouseEvent) => void;
	}

	const {
		url,
		color = 'primary',
		size = 'sm',
		variant = 'filled',
		class: classes = 'w-full',
		onBookClick,
	}: Props = $props();

	let isOpen = $state(false);

	function closeModal() {
		isOpen = false;
	}
</script>

<Button
	{variant}
	{color}
	{size}
	class={classes}
	icon="restaurant"
	text={m.poi_actions__book()}
	onclick={(event) => {
		event.stopPropagation();
		onBookClick?.(event);
		isOpen = true;
	}}
	onmousedown={(e) => {
		e.stopPropagation();
	}}
	onpointerdown={(e) => {
		e.stopPropagation();
	}}
/>

<ModalDialog
	bind:open={isOpen}
	closeText={m.settings__close()}
	centered
	contentDialogClasses={$isMobile ? 'size-full' : ''}
	closeCallback={closeModal}
>
	{#snippet closeButtonSlot()}
		<Button
			variant="outline"
			color="white"
			size="sm"
			icon="close"
			iconPosition="right"
			class="absolute top-0 right-0 border-none bg-transparent cursor-pointer"
			onclick={(event) => {
				event.stopPropagation();
				isOpen = false;
			}}
		/>
	{/snippet}

	<TheForkWidgetDialog {url} />
</ModalDialog>
